import { AnyAction } from 'redux';

import { EventsReceivedAction, EVENTS_RECEIVED } from '@ttstr/actions/events';
import { Articles, IndexedEvents, Product } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  eventsReceived: boolean;
  events: IndexedEvents;
}

const initialState: ReduxState = {
  eventsReceived: false,
  events: {},
};

const events = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case EVENTS_RECEIVED: {
      const { events } = (action as EventsReceivedAction).payload;

      if (!events) return state;

      return {
        ...state,
        eventsReceived: true,
        events: events.reduce(
          (previous, current) => ({
            ...previous,
            [current.id]: current,
          }),
          {}
        ),
      };
    }
    default:
      return state;
  }
};

export const getEvents = (state: AppState) => {
  return state.Events.events;
};

export const getEventsReceived = (state: AppState) => {
  return state.Events.eventsReceived;
};

export const getEventFromProduct = (events: IndexedEvents, product: Product) => {
  return events[product.event_id];
};

export const getEventsForProducts = (events: IndexedEvents, products: Articles) => {
  if (!events) return {};
  return Object.entries(events).reduce<IndexedEvents>(
    (acc, [id, event]) => (products.some((p) => p.event_id === Number(id)) ? { ...acc, [id]: event } : acc),
    {}
  );
};

export default events;
